import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const FAQSection = memo(({ theme, sectionId }) => {
  const FAQLayout = dynamic(() => import(/* webpackChunkName: 'FAQSectionLayout' */ `../../../../../containers/home-page/views/sections/faq/layouts/${theme.layout}`))

  return (
    <FAQLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

FAQSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default FAQSection
